import { render, staticRenderFns } from "./LargeCabin.vue?vue&type=template&id=052a4e1c&scoped=true"
import script from "./LargeCabin.vue?vue&type=script&lang=js"
export * from "./LargeCabin.vue?vue&type=script&lang=js"
import style0 from "./LargeCabin.vue?vue&type=style&index=0&id=052a4e1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052a4e1c",
  null
  
)

export default component.exports